import { OpenLRCoordinate } from './openlrcoordinate.model';
import { OpenLRLineAttributes } from './openlrlineattributes.model';
import { OpenLRPathAttributes } from './openlrpathattributes.model';

export class OpenLRLocationReferencePoint {
  openlrCoordinate: OpenLRCoordinate;
  openlrLineAttributes: OpenLRLineAttributes;
  openlrPathAttributes: OpenLRPathAttributes;
}



// WEBPACK FOOTER //
// ./src/app/models/openlr/openlrlocationreferencepoint.model.ts